import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SalService } from 'src/app/Services/sal/sal.service';
import { Router } from '@angular/router';
import { ConfirmationDialogService } from 'src/app/services/sal/confirmation-dialog.service';

@Component({
  selector: 'app-service-renewal',
  templateUrl: './service-renewal.component.html',
  styleUrls: ['./service-renewal.component.css']
})
export class ServiceRenewalComponent implements OnInit {

  Submitted:boolean=false;
   Action:any="Add";
  constructor(private router: Router,private confirmationDialogService: ConfirmationDialogService,
    private Productservice: SalService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }
 
    SaleModel = {         
      IsActive: true,     
      PaymentID:0,
      CategoryID:0,
      ToDate:'',
      BranchID:0,
      FromDate:'',
      ReceiptNo:'',
      InvoiceNo:'',
      SubscriptionStatusID:0,
  };
  SubscriptionList:any;
  GetSubscriptionRenewal(SubscriptionStatusID) {
    this.SaleModel.SubscriptionStatusID=SubscriptionStatusID
    this.spinnerService.show();
      this.Productservice.GetCustomerSubscription(JSON.stringify(this.SaleModel)).subscribe((response: any) => {
          this. SubscriptionList = response.CustomerSubscriptionList;
          if( this.SubscriptionList!=null && this.SubscriptionList.length>0){
            this.OrganizationCountryID=this.SubscriptionList[0].OrganizationCountryID;
            this.OrganizationStateID=this.SubscriptionList[0].OrganizationStateID;
            this.CountryID=this.SubscriptionList[0].CountryID;
            this.StateID=this.SubscriptionList[0].StateID;
          }
          this.spinnerService.hide();
          this.globalHelper.CheckActionStatus(response);
      });
  };




  Clear = function () {
      this.Action="Add";
      this.SaleModel.CustomerID = 0;
      this.SaleModel.InvoiceNo = "";
      this.SaleModel.ReceiptNo = '';
      this.SaleModel.FromDate = '';
      this.SaleModel.ToDate = '';    
      this.ProductDescription='';
      this.SaleModel.IsActive = true;
      this.Submitted = false;    
      this.GetSubscription(); 
  };
  CategoryList:any;
  GetCategory() {
    this.lookupservice.GetLookupsList('Category', '').subscribe((data: any) => {
      this.CategoryList = data.LookupItems;
      
    });
  };

  PaymentModel = {
    BranchID:0,
    CustomerID: 0,
    OrderAmount: 0,
    TaxAmount:0,
    TotalAmount:0,
    PageAction: '',
    OrderNo: '',
    InvoiceNo: '',
    NetAmount:0,
    CurrencyCode:"",
    CurrencyRate:0,
    OrderType:"",
    CurrencySymbol:""
    
  };
  OrganizationCountryID:any;
  OrganizationStateID:any;
  CurrencyCode:any;
  CountryID:any;
  StateID:any;
  GetAllTotal(item) {
    item.IsSelect=item.IsSelect==true?false:true;
  
    var TotalAmount = 0;   
   
    for (var i = 0; i < this.SubscriptionList.length; i++) {
     
      if(this.SubscriptionList[i].IsSelect==true && this.SubscriptionList[i].Price>0){  
        
      TotalAmount = TotalAmount + this.SubscriptionList[i].Price;
     }
    }
    this.PaymentModel.CurrencyCode =item.CurrencyCode;
    this.PaymentModel.CurrencyRate =item.CurrencyRate;
    this.PaymentModel.TotalAmount =TotalAmount;  
    this.PaymentModel.OrderAmount =TotalAmount;   
    this.PaymentModel.NetAmount = TotalAmount;
    this.PaymentModel.OrderType="RENEWAL";
    this.PaymentModel.BranchID=this.SaleModel.BranchID;
  }
   Alertmsg="";
  SaveSaleOrderCustomer() {
   if(this.PaymentModel.OrderAmount>0){
    this.Alertmsg="";
   
    this.confirmationDialogService.confirm('Please confirm..', 'Please click on OK to pay this order or Cancel to go back. ?')
   .then(confirmed => {
    if(confirmed){
      this.spinnerService.show();
      this.Productservice.SaveRenewalService(JSON.stringify(this.SubscriptionList), JSON.stringify(this.PaymentModel)).subscribe((data: any) => {
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
        if (data.webResponse.Status) {
          this.PaymentModel.OrderNo = data.OrderNo;
         
          this.Pay(this.PaymentModel.OrderNo)
        }
      }
      );
    }
  })
  .catch(err => {
    console.log(err);
  });
    
}else{
this.Alertmsg="Please Check at Least One Service"

}

    

  }
  Pay(OrderNo) {
    
    window.localStorage.removeItem("ReceiptNo");
    window.localStorage.removeItem("razorpay_payment_id");
    window.localStorage.removeItem("razorpay_signature");
    window.localStorage.removeItem("razorpay_order_id");
    this.router.navigate(['/pay'], {state: {OrderNo:OrderNo}})
   
}
BranchList: any;
GetAllBranch() {   
  var itembo={
         ItemId :this.globalHelper.GetLoginToken().SchoolID
           }
  this.lookupservice.GetLookupsList('BranchBySchool',JSON.stringify(itembo)).subscribe((data: any) => {
    this.BranchList = data.LookupItems;
    

  });
};
  ngOnInit() {
this.GetAllBranch();
// this.GetSubscriptionRenewal(0);
  }
}
